import Separator from 'components/common/separator';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import CruisePurchaseCruiseCard from './cruise-card';
import CruiseGuestCard from './guest-card';

export default function CruiseItems() {
  const { control } = useFormContext();
  const cruisePurchases = useWatch({
    control,
    name: 'approvalable.cruisePurchases',
  });

  return (
    <>
      <CruisePurchaseCruiseCard />
      <Separator gap={22} />

      {cruisePurchases.map((cp, idx) => (
        <React.Fragment key={cp.id}>
          <CruiseGuestCard parentIndex={idx} />
          <Separator gap={22} />
        </React.Fragment>
      ))}
    </>
  );
}
